import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination, Navigation, EffectFade } from 'swiper';
import Card from './Card';
import './Card/index.css';
import { useDispatch, useSelector } from 'react-redux';
import { actionTypes } from './../../../../../redux/slider/select_slider/index'

SwiperCore.use([Autoplay, Pagination, Navigation]);

let useSyles = makeStyles(() => ({
    root: {
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        '& > div ': {
            marginBottom: 15,
        }
    },
}))

export default function Index() {

    let classes = useSyles();
    const dispatch = useDispatch();
    const swiperRef = useRef(null);

    const [sort, setSort] = useState({});
    const [state, setstate] = useState([]);
    const [flagApi, setflagApi] = useState(false);
    const [stateTable, setStateTable] = useState({});
    const [pagnation, setPagnation] = useState({ number: 1, count: 2 });


    const stateReducer = useSelector(state => state.select_slider_reducer)


    const apiSubmit = () => {
        let obj = {};
        let { size } = stateReducer;
        let { id, ...sortRes } = sort;

        Object.keys(stateTable).forEach((element) => {
            if (stateTable[element]) {
                obj[element] = stateTable[element];
            }
        });

        let _data = {
            data: obj,
            from: pagnation.number,
            size: size,
            sort_by: sortRes,
        };

        dispatch({ type: actionTypes.selectSliderAsync, payload: _data })

    };

    const getLinkType = (link) => {
        if (link?.startsWith("tel:")) {
            return "Phone";
        } else if (link?.startsWith("http://") || link?.startsWith("https://")) {
            return "Link";
            return "external";
        } else {
            return null;
            return "internal";
        }
    }

    useEffect(() => {
        if (stateReducer?.data?.length) {
            let data = stateReducer?.data
            let res = data?.map((item, index) => {
                let content = JSON?.parse(item?.content)
                return (
                    {
                        "id": index,
                        "order": item?.order ?? 0,
                        "body": {
                            "title": content?.titles?.title1,
                            "description": content?.titles?.title2,
                            "first_button": {
                                "type": getLinkType(content?.buttons?.button1?.link),
                                "title": content?.buttons?.button1?.context,
                                "hidden_title": content?.buttons?.button1?.link,
                            },
                            "second_button": {
                                "type": getLinkType(content?.buttons?.button2?.link),
                                "title": content?.buttons?.button2?.context,
                                "hidden_title": content?.buttons?.button2?.link,
                            },
                            "is_visible": "TRUE",
                            "image_content": item?.imageData
                        }
                    }
                )
            })
                ?.sort((a, b) => a.order - b.order)
                ?.reverse();


            setstate(res);
            setPagnation((prev) => ({
                ...prev,
                count: Math.ceil(stateReducer.total / stateReducer.size),
            }));
        }

    }, [stateReducer]); //eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {

        apiSubmit();

    }, [flagApi])//eslint-disable-line react-hooks/exhaustive-deps



    return (
        <div className={classes['root']}>
            {state?.length > 0 ? (
            <Swiper
                ref={swiperRef}
                slidesPerView={'auto'}
                spaceBetween={0}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
                centeredSlides={true}
                loop={state?.length > 1 ? true : false}
                modules={[Autoplay, Pagination, Navigation]}
                pagination={{
                    clickable: true,
                }}
                className="mySwiper"
                navigation={{
                    prevEl: '.prevNavigation',
                    nextEl: '.nextNavigation',
                }}

            >
                {
                    state
                        ?.filter((item) => item?.body?.is_visible === 'TRUE')
                        ?.map((silde, index) => {
                            return (
                                <SwiperSlide key={silde?.id ?? silde?.body?.title ?? index}>
                                    <Card
                                        data={silde}
                                        flagShowArrow={true}
                                        swiperRef={swiperRef}
                                    />
                                </SwiperSlide>
                            )
                        })
                }
            </Swiper>
            ) : null}

            <button className="prevNavigation" id='prevNavigation' style={{ width: 0, overflow: 'hidden', display: 'none' }}>prevNavigation</button>
            <button className="nextNavigation" id='nextNavigation' style={{ width: 0, overflow: 'hidden', display: 'none' }}>nextNavigation</button>
        </div >)
        ;
}
